import React from "react";


import { connect } from "react-redux";
import ActivityLogSubComponent from "./ActivityLogSubComponent";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import CommontTitleWithBackButton from "../commonTitleComponent/commontTitleWithBackButton";
import Footer from "../footerComponent/Footer";


class ManageConsumers extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			password:'',
			otpRef:'',
			message:''
		}
    }

	
    componentDidMount(){}
	componentWillUnmount(){
    }

  
    

    render(){

    var headerTitle="Activity Log";
    return(
        
     <div>
    <div class="main">
        <LeftMenu/>

        <div class="right-side">
		<div class="container-fluid">

		<Header/>

        <div class="row">
        <div class="col-12">
            <div class="card">
                <CommontTitleWithBackButton headerTitle={headerTitle}/>     
                <ActivityLogSubComponent/>					
            </div>
        </div>
        </div>

        </div>
        </div>
   
    </div>
    <Footer/>
    </div>
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(ManageConsumers);
